import api from './api';

/**
 * Consultation Service
 * Handles all consultation-related API calls
 */

const consultationService = {
  /**
   * Get user's consultations
   * @param {Object} filters - Query filters (status, limit, offset)
   * @returns {Promise} List of consultations
   */
  getConsultations: (filters = {}) => {
    return api.get('/consultations', { params: filters });
  },

  /**
   * Get specific consultation details
   * @param {number} id - Consultation ID
   * @returns {Promise} Consultation details
   */
  getConsultation: (id) => {
    return api.get(`/consultations/${id}`);
  },

  /**
   * Update consultation (end or cancel)
   * @param {number} id - Consultation ID
   * @param {Object} data - Update data (action, notes, etc.)
   * @returns {Promise} Updated consultation
   */
  updateConsultation: (id, data) => {
    return api.put(`/consultations/${id}`, data);
  },

  /**
   * Get consultation messages
   * @param {number} id - Consultation ID
   * @param {Object} params - Query params (limit, offset, before_message_id)
   * @returns {Promise} List of messages
   */
  getMessages: (id, params = {}) => {
    return api.get(`/consultations/${id}/messages`, { params });
  },

  /**
   * Send a message in consultation (REST fallback for Socket.IO)
   * @param {number} id - Consultation ID
   * @param {string} content - Message content
   * @param {string} messageType - Message type (text, file)
   * @returns {Promise} Sent message
   */
  sendMessage: (id, content, messageType = 'text') => {
    return api.post(`/consultations/${id}/messages`, {
      content,
      message_type: messageType
    });
  },

  /**
   * Get consultation status and remaining time
   * @param {number} id - Consultation ID
   * @returns {Promise} Status data
   */
  getConsultationStatus: (id) => {
    return api.get(`/consultations/${id}/status`);
  }
};

export default consultationService;
